// extracted by css-extract-rspack-plugin
export default {"Box":"x-axis-selector-module__Box__zE6Q2"};